import { createFileRoute, notFound } from "@tanstack/react-router";
import { legacyRedirect } from "@/lib/legacy-redirect";

// Retired /louisville-ky/* landing pages — content merged into the canonical service pages
const LEGACY_PATHS: Record<string, string> = {
  "emergency-electrician": "/electrical-services/emergency-electrical-service",
  "generator-installation": "/electrical-services/generator-installation",
  "hvac-contractor": "/hvac-services",
  "commercial-electrician": "/electrical-services/commercial-electrical-contractor",
  "lighting-contractor": "/energy-management/lighting-retrofits",
  "air-conditioning-contractor": "/hvac-services/ac-installation-repair",
};

export const Route = createFileRoute("/louisville-ky/$")({
  beforeLoad: ({ params }) => {
    const target = LEGACY_PATHS[params._splat ?? ""];
    if (target) legacyRedirect(target);
    throw notFound();
  },
});
